import { getResult } from "../../core/helpers/functional-util.js";

/**
 * An option can be either active or inactive and provides an API that trigger
 * different behaviors according to this state.
 *
 * @param {boolean} [active] - True when the option is active
 */
export default class Option {
	constructor({ active = false } = {}) {
		this._active = active;
		this.isFeature = true; // ⇐ used by buildRule()
	}

	isActive() {
		return this._active;
	}

	when({ active, inactive }) {
		if (this.isActive()) {
			return getResult(active);
		}
		return getResult(inactive);
	}

	whenActive(arg) {
		return this.when({
			active: arg,
			inactive: null,
		});
	}

	whenInactive(arg) {
		return this.when({
			active: null,
			inactive: arg,
		});
	}

	renderWhenActive(renderable) {
		return (html) => {
			if (!this.isActive()) {
				return;
			}
			html.render(renderable);
		};
	}

	asRoutingRule() {
		return this.isActive();
	}

	isTabEnabled() {
		return this.isActive();
	}
}
